"use client";

import { MarketNavElements } from "@faire/retailer-visitor-shared/features/FaireMarkets/Navigation/MarketNavElements";
import { useMarketStore } from "@faire/retailer-visitor-shared/stores/domain/Events/FaireMarkets/MarketStore";
import { Spacer } from "@faire/web/slate/spacing";
import React from "react";

import { HeaderLine } from "../styled";

export const MarketLinksSection = () => {
  const { showAllSpecials } = useMarketStore();
  return showAllSpecials ? (
    <>
      <MarketNavElements />
      <HeaderLine />
      <Spacer width="1x" />
    </>
  ) : null;
};
